import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { ReplacementModelRecord } from '../entities/records';
import * as selectors from '../entities/ReplacementModel/selectors';

function mapStateToProps(state, { replacementModelId }) {
  return {
    replacementModel: selectors.replacementModelById(state, replacementModelId),
  };
}

export default compose(
  setPropTypes({
    replacementModelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    replacementModel: PropTypes.instanceOf(ReplacementModelRecord),
  }),
)(mapStateToProps);
